import React from 'react';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';

import VpPluginsTableHead from './VpPluginsTableHead';
import VpPluginsTableBody from './VpPluginsTableBody';
import VpPluginsTablePagination from './VpPluginsTablePagination';

export const VpPluginsTable = () => {
  return (
    <TableContainer>
      <Table>
        <VpPluginsTableHead />
        <VpPluginsTableBody />
      </Table>
      <VpPluginsTablePagination />
    </TableContainer>
  );
};

export default VpPluginsTable;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpPluginsTable/VpPluginsTable.jsx